import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=32daf4a8"
import script from "./GroupMenu.vue?vue&type=script&lang=js"
export * from "./GroupMenu.vue?vue&type=script&lang=js"
import style0 from "./GroupMenu.vue?vue&type=style&index=0&id=32daf4a8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports